import { useCallback, useState } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { ModeEditIcon, NoteAddRoundedIcon } from "@l2r-front/l2r-icons"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { useAlertsDispatchContext } from "@l2r-front/l2r-query"
import { UiModal } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../constants/i18n"

const POPUP_WIDTH = 900
const POPUP_HEIGHT = 670

export const DocumentEditModal = (props) => {

    const {
        attachedObjectType,
        className,
        FormComponent,
        mode,
        documentLocation,
        open,
        onClose,
        ...formProps
    } = props

    const [hasOngoingModifications, setHasOngoingModifications] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const { t } = useTranslation(I18N_NAMESPACE)
    const { setAlert } = useAlertsDispatchContext()

    const handleClose = useCallback((checkModifications = true) => {
        if (checkModifications && hasOngoingModifications) {
            setAlert({
                alertTitle: t(I18N_NAMESPACE, `containers.documentEditModal.alert.title.${mode === "add" ? "add" : "update"}`),
                cancelText: t(I18N_NAMESPACE, "containers.documentEditModal.alert.cancelButton"),
                confirmText: t(I18N_NAMESPACE, "containers.documentEditModal.alert.confirmButton"),
                callback: () => {
                    setHasOngoingModifications(false)
                    onClose()
                },
                severity: "warning",
            })
        } else {
            setHasOngoingModifications(false)
            onClose()
        }
    }, [hasOngoingModifications, t, onClose, setAlert, mode])

    return <UiModal
        id="add-document-modal"
        className={className}
        height={POPUP_HEIGHT}
        width={POPUP_WIDTH}
        open={!!open}
        onClose={handleClose}
        interactive={!isSubmitting}
        title={t(I18N_NAMESPACE, `containers.documentAddModal.title.${mode === "add" ? "add" : "update"}`)}
        titleIcon={mode === "add" ? <NoteAddRoundedIcon sx={{ height: "100%" }} /> : <ModeEditIcon sx={{ height: "100%" }} />}
    >
        <FormComponent
            sx={{ flex: "1 1 auto" }}
            attachedObjectType={attachedObjectType}
            documentLocation={documentLocation}
            onClose={handleClose}
            onSubmitting={(submitting) => setIsSubmitting(submitting)}
            onChange={setHasOngoingModifications}
            {...formProps} />
    </UiModal>
}

DocumentEditModal.propTypes = {
    attachedObjectType: PropTypes.string,
    className: PropTypes.string,
    mode: PropTypes.oneOf(["add", "update"]).isRequired,
    open: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
    onClose: PropTypes.func.isRequired,
}

DocumentEditModal.defaultProps = {
    className: "",
    mode: "add",
}